import { createFormAction } from "redux-form-saga";
export const HANDOVER_FORM_KEY = 'ASSET_HANDOVER_FORM'
export const AssetHandoverFormAction = createFormAction(HANDOVER_FORM_KEY)

